import { ComputeExpressionSchema } from '@framework/engine/schema/expressions/compute/validation/ComputeExpressionSchema.ts';
import { BaseLayoutSchema } from '@framework/engine/schema/widgets/repository/common/BaseLayoutSchema.ts';
import { CommonInputWidgetConfigSchema } from '@framework/engine/schema/widgets/repository/inputs/common/CommonInputConfigComponent.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { type IBurdenWidget, WidgetTypeBurden } from './IBurdenWidget.ts';

export const BurdenWidgetConfigSchema: yup.ObjectSchema<IBurdenWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().required().exact(WidgetTypeBurden).label('Tipo'),
    macroBurdenTypeId: yup.string().required().label('Tipo di onere'),
    macroBurdenType: yup.object(),
    showVisualAsterisk: yup
      .boolean()
      .required()
      .default(false)
      .label('Mostra asterisco obbligatorietà'),
    expression: ComputeExpressionSchema.label('Importo Calcolato'),
    layout: BaseLayoutSchema.shape({
      hide: yup.boolean().required().default(false).label('Nascondi elemento'),
      removeBorder: yup
        .boolean()
        .required()
        .default(false)
        .label('Rimuovi bordo'),
    }),
  })
    .required()
    .noUnknown();
